<fnma-header
  [appName]="'Financial Risk Management'"
  [firstLevelMenu]="firstLevelMenu()"
  [enableNotification]="true"
  [enableSearch]="false"
  [enableFavourite]="false"
  [notificationCount]="0"
  [customIcons]="[]"
  [username]="username()"
  [alignMenuRight]="true"
  [profileMenuItems]="profileMenuItems()">
</fnma-header>
